import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Card, Space, message } from 'antd';
import { LineChartOutlined, QuestionCircleOutlined, ReloadOutlined, RocketOutlined, SendOutlined, TeamOutlined } from '@ant-design/icons';
import Dragger from 'antd/es/upload/Dragger';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';

const { TextArea } = Input;

export default function ViolationReportForm() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = useState([]);

    const [otherTeam, setOtherTeam] = useState('');
    const [otherViolationType, setOtherViolationType] = useState('');


    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedViolationType, setSelectedViolationType] = useState(null);

    const teamOptions = [
        { label: 'Sales', value: 'sales', icon: <LineChartOutlined style={{ fontSize: 24, color: '#1890ff' }} /> },
        { label: 'Operations', value: 'operations', icon: <RocketOutlined style={{ fontSize: 24, color: '#722ed1' }} /> },
        { label: 'Marketing', value: 'marketing', icon: <TeamOutlined style={{ fontSize: 24, color: '#eb2f96' }} /> },
        { label: 'Other', value: 'other', icon: <QuestionCircleOutlined style={{ fontSize: 24, color: '#faad14' }} /> },
    ];

    const violation_type = [
        { label: 'Sharing client contact info without approval', value: 'client_contact_info_without_approval' },
        { label: 'Contacting client without authorization', value: 'client_without_authorization' },
        { label: 'Exporting or downloading client data', value: 'exporting_downloading_client_data' },
        { label: 'Other', value: 'other' },
    ];

    const onSelectTeam = (value) => {
        setSelectedTeam(value);
        setOtherTeam('');
        if (value === 'other') {
            form.setFieldsValue({ team: '' }); // Will be filled from input
        } else {
            form.setFieldsValue({ team: value });
        }
    };

    const onSelectViolationType = (value) => {
        setSelectedViolationType(value);
        setOtherViolationType('');
        if (value === 'other') {
            form.setFieldsValue({ violation_type: '' }); // Will be filled from input
        } else {
            form.setFieldsValue({ violation_type: value });
        }
    };


    const handleUploadChange = (info) => {
        if (info.fileList.length > 0) {
            setFileList(info.fileList || []);
        } else {
            setFileList([]);
        }
    };

    const onFinish = async (values) => {
        setLoading(true);

        try {
            const formData = new FormData();

            for (const key in values) {
                if (values[key]) {
                    formData.append(key, values[key]);
                }
            }

            if (fileList.length > 0) {
                fileList.forEach(file => {
                    formData.append('evidence_files', file.originFileObj);
                });
            }
            const response = await axiosInstance.post('/task/v2/report-data-violation/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response?.status === 201) {
                message.success(response?.data?.message);
                form.resetFields();
                setFileList([]);
                setSelectedTeam(null);
                setSelectedViolationType(null);
                setOtherTeam('');
                setOtherViolationType('');
            }
        } catch (error) {
            await catchError(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div style={{ padding: "15px 0px 0px 24px", textAlign: "left" }}>
                Your IP address or name will not be tracked. You can submit this report anonymously.</div>
            <div style={{ margin: '20px', padding: 24, background: '#fff', borderRadius: 8 }}>

                <Form form={form} layout="vertical" onFinish={onFinish} style={{ textAlign: "left" }}>

                    <Form.Item
                        label={<strong>1. Which team committed the violation</strong>}
                        name="team"
                        rules={[{ required: true, message: 'Please select a team' }]}
                    >
                        <Row gutter={[16, 16]}>
                            {teamOptions.map(({ label, value, icon }) => (
                                <Col xs={24} sm={12} md={6} key={value}>
                                    <Card
                                        size="small"
                                        hoverable
                                        onClick={() => onSelectTeam(value)}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: selectedTeam === value ? '#e6f7ff' : '#fafafa',
                                            borderColor: selectedTeam === value ? '#1890ff' : '#d9d9d9',

                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: "flex-start",
                                            alignItems: 'center',
                                            width: "100%",
                                            gap: "10px"
                                        }}>

                                            <div>{icon}</div>
                                            <div>{label}</div>
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Form.Item>

                    {selectedTeam === 'other' && (
                        <Form.Item
                            name="team"
                            rules={[{ required: true, message: 'Please specify the team' }]}
                        >
                            <Input
                                placeholder="Please specify the team"
                                value={otherTeam}
                                onChange={(e) => {
                                    setOtherTeam(e.target.value);
                                    form.setFieldsValue({ team: e.target.value });
                                }}
                            />
                        </Form.Item>
                    )}

                    <Form.Item
                        label={<strong>2. Type of Violation Observed:</strong>}
                        name="violation_type"
                        rules={[{ required: true, message: 'Please specify the violation type' }]}
                    >
                        <Row gutter={[8, 8]}>
                            {violation_type.map(({ label, value }) => (
                                <Col xs={24} sm={12} md={12} key={value}>
                                    <Card
                                        size="small"
                                        hoverable
                                        onClick={() => onSelectViolationType(value)}


                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: selectedViolationType === value ? '#e6f7ff' : '#fafafa',
                                            borderColor: selectedViolationType === value ? '#1890ff' : '#d9d9d9',

                                        }}
                                    >
                                        {label}
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Form.Item>

                    {selectedViolationType === 'other' && (
                        <Form.Item
                            name="violation_type"
                            rules={[{ required: true, message: 'Please describe the violation type' }]}
                        >
                            <Input
                                placeholder="Please describe the violation type"
                                value={otherViolationType}
                                onChange={(e) => {
                                    setOtherViolationType(e.target.value);
                                    form.setFieldsValue({ violation_type: e.target.value });
                                }}
                            />
                        </Form.Item>
                    )}
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item
                                label={<strong>3. Brief Description of the Incident:</strong>}
                                name="description"
                                rules={[
                                    { required: true, message: 'Please provide a description of the incident' },
                                    { min: 20, message: 'Please provide at least 20 characters' },
                                ]}
                            >
                                <TextArea
                                    rows={6}
                                    maxLength={2000}
                                    placeholder="What happened? Who was involved? When did it occur?"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>

                            <Form.Item
                                label={<strong>4. Do you have any evidence? (You can upload files or give a reference)</strong>}
                            >
                                <Dragger
                                    style={{ minHeight: "140px" }}
                                    multiple
                                    maxCount={10}
                                    beforeUpload={() => false}
                                    fileList={fileList}
                                    onChange={handleUploadChange}
                                    onRemove={(file) =>
                                        setFileList((prev) => prev.filter((f) => f.uid !== file.uid))
                                    }
                                >
                                    <p className="ant-upload-text">Click or drag files to this area to upload</p>
                                    <p className="ant-upload-hint">
                                        You can upload multiple screenshots, documents, etc. (files won't be uploaded immediately)
                                    </p>
                                </Dragger>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        label={<strong>5. Anything else you'd like to share?</strong>}
                        name="additional_info"
                    >
                        <TextArea
                            rows={4}
                            maxLength={1000}
                            placeholder="Additional context, concerns, or relevant information."
                        />
                    </Form.Item>

                    <Form.Item style={{ textAlign: 'right' }}>
                        <Space>
                            <Button
                                onClick={() => {
                                    form.resetFields();
                                    setSelectedTeam(null);
                                    setSelectedViolationType(null);
                                    setFileList([]);
                                }}
                                icon={<ReloadOutlined />}
                            >
                                Clear Form
                            </Button>

                            <Button
                                type="default"
                                htmlType="submit"
                                loading={loading}
                                icon={<SendOutlined />}
                                style={{ backgroundColor: '#000', color: '#fff', border: 'none' }}
                            >
                                Submit Report
                            </Button>
                        </Space>
                    </Form.Item>

                </Form >
            </div >
        </>

    );
}
